import { Alert, Checkbox, FormControlLabel, Stack } from '@mui/material';

import { useOrganizationDialog } from './OrganizationEditDialog.hooks';

export const OrganizationEditDialogContentCleanUp = ({
  repos
}: {
  repos: string[];
}) => {
  const { repoNames, setRepoNames } = useOrganizationDialog();

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const repoName = e.target.value;
    const isChecked = e.target.checked;
    if (isChecked && !repoNames.includes(repoName)) {
      setRepoNames((prev) => [...prev, repoName]);
    } else if (!isChecked && repoNames.includes(repoName)) {
      setRepoNames((prev) => prev.filter((r) => r !== repoName));
    }
  };

  return (
    <>
      {repos.length === 0 && (
        <Alert severity="info" sx={{ mt: 2 }}>
          No LogScale repositories found for this organization. Clean up is
          still available for this organization&apos;s users, LogScale group,
          and Auth0 organization.
        </Alert>
      )}
      {repos.length > 0 && (
        <>
          <Alert severity="info" sx={{ mt: 2 }}>
            Check the title of each LogScale repository that you want to remove:
          </Alert>
          <Stack sx={{ marginTop: '1rem' }}>
            {repos.map((repo) => (
              <FormControlLabel
                key={repo}
                control={
                  <Checkbox
                    value={repo}
                    checked={repoNames.includes(repo)}
                    onChange={handleCheck}
                  />
                }
                label={repo}
              />
            ))}
          </Stack>
        </>
      )}
    </>
  );
};

export default OrganizationEditDialogContentCleanUp;
